import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;

  .fc {
    ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
    height: 100%;
    z-index: ${index(Options.PAGE)};

    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .fc table {
    border-width: 0;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-body:first-child {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-scrollgrid-section-sticky > * {
    background: transparent;
  }

  /* Header cells */
  .fc .fc-day-sat,
  .fc .fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  /* TimeGrid columns (where events are) */
  .fc .fc-timegrid-col.fc-day-sat,
  .fc .fc-timegrid-col.fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  .fc .fc-col-header-cell-cushion {
    padding: ${({ theme }) => theme.spacing(2)};
  }

  .fc-header-toolbar {
    display: none;
  }

  .fc-timegrid-divider {
    display: none;
  }

  .fc-timegrid-col,
  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-more-popover {
    visibility: hidden;
    height: 0;
    width: 0;
    overflow: hidden;
  }

  .fc .fc-daygrid-day-top {
    display: flex;
    align-items: center;
    padding: ${({ theme }) => `0 ${theme.spacing(1)} 0 0`};
    height: 2.6rem;
  }

  .fc-daygrid-day.fc-day-today,
  .fc-timegrid-col.fc-day-today {
    background: inherit;

    .fc-daygrid-day-number {
      padding: ${({ theme }) => `${theme.spacing(0.25)} ${theme.spacing(1.5)}`};

      border-radius: ${({ theme }) => theme.spacing(1)};
      background-color: ${({ theme }) => theme.palette.error.dark};

      color: ${({ theme }) => theme.palette.error.contrastText};
    }
  }

  .fc-timegrid-event .fc-event-main {
    padding: 0;
  }

  .fc .fc-highlight {
    background: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
  }

  .fc-col-header-cell,
  .fc-day {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-scrollgrid-section td,
  .fc-scrollgrid-section th {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-scrollgrid-section .fc-timegrid-slot-minor {
    border-top-color: transparent;
  }

  .fc-event {
    margin: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1)} 0`};
    padding: 0;

    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
`;
